import { useQuery } from '@tanstack/react-query';
import { getLicenseStatus } from '@/lib/api';
import type { LicenseStatusResponse } from '@/types/api';

export const licenseQueryKeys = {
  status: () => ['license', 'status'] as const,
  details: () => ['license', 'details'] as const,
};

export function useLicenseStatus() {
  return useQuery<LicenseStatusResponse>({
    queryKey: licenseQueryKeys.status(),
    queryFn: getLicenseStatus,
    staleTime: 60_000,
    retry: 2,
  });
}
